import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('home');

  return (
    <footer className="bg-ink-800 pt-14 md:pt-18 pb-8 text-white">
      <div className="w-full px-4 md:px-6 lg:px-10">
        {/* Main Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 pb-10">
          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold text-warm-500 uppercase tracking-[0.15em] mb-4">{t('footer.company')}</h4>
            <ul className="space-y-3">
              <li><a href="/about" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.about')}</a></li>
              <li><a href="/careers" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.careers')}</a></li>
              <li><a href="/press" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.press')}</a></li>
              <li><a href="/blog" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.blog')}</a></li>
            </ul>
          </div>

          {/* Packaging */}
          <div>
            <h4 className="text-xs font-semibold text-warm-500 uppercase tracking-[0.15em] mb-4">{t('footer.packaging')}</h4>
            <ul className="space-y-3">
              <li><a href="/packaging" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.browse')}</a></li>
              <li><a href="/packaging?filter=categories" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.categories')}</a></li>
              <li><a href="/packaging?filter=others" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.others')}</a></li>
            </ul>
          </div>

          {/* Customization */}
          <div>
            <h4 className="text-xs font-semibold text-warm-500 uppercase tracking-[0.15em] mb-4">{t('footer.customization')}</h4>
            <ul className="space-y-3">
              <li><a href="/customization" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.finishing')}</a></li>
              <li><a href="/ai-preview" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.aiPreview')}</a></li>
              <li><a href="/customization?tab=design" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.design')}</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-xs font-semibold text-warm-500 uppercase tracking-[0.15em] mb-4">{t('footer.support')}</h4>
            <ul className="space-y-3">
              <li><a href="/help" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.help')}</a></li>
              <li><a href="/shipping" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.shipping')}</a></li>
              <li><a href="/returns" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.returns')}</a></li>
              <li><a href="/contact" className="text-sm text-white/50 hover:text-warm-400 transition-colors">{t('footer.contact')}</a></li>
            </ul>
          </div>
        </div>

        {/* Payment Methods & SNS Row */}
        <div className="py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Payment Methods */}
          <div className="flex items-center gap-2">
            <span className="text-xs text-white/30 mr-1">Secure Payment</span>
            <div className="flex items-center gap-1.5">
              <div className="w-11 h-7 bg-white/90 flex items-center justify-center overflow-hidden">
                <span className="text-[9px] font-black italic text-[#1A1F71] tracking-tighter">VISA</span>
              </div>
              <div className="w-11 h-7 bg-white/90 flex items-center justify-center overflow-hidden relative">
                <div className="flex -space-x-1.5">
                  <div className="w-4 h-4 bg-[#EB001B]"></div>
                  <div className="w-4 h-4 bg-[#F79E1B]"></div>
                </div>
              </div>
              <div className="w-11 h-7 bg-[#016FD0] flex items-center justify-center overflow-hidden">
                <span className="text-[7px] font-black text-white tracking-tighter">AMEX</span>
              </div>
              <div className="w-11 h-7 bg-white/90 flex items-center justify-center overflow-hidden">
                <span className="text-[8px] font-black text-[#003087] tracking-tighter">Pay<span className="text-[#009CDE]">Pal</span></span>
              </div>
            </div>
          </div>

          {/* SNS Icons */}
          <div className="flex items-center gap-3">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer nofollow" className="w-9 h-9 border border-white/15 flex items-center justify-center text-white/40 hover:text-warm-400 hover:border-warm-500/50 transition-all">
              <i className="ri-facebook-fill text-base" />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer nofollow" className="w-9 h-9 border border-white/15 flex items-center justify-center text-white/40 hover:text-warm-400 hover:border-warm-500/50 transition-all">
              <i className="ri-youtube-fill text-base" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer nofollow" className="w-9 h-9 border border-white/15 flex items-center justify-center text-white/40 hover:text-warm-400 hover:border-warm-500/50 transition-all">
              <i className="ri-instagram-line text-base" />
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-warm-500 flex items-center justify-center">
              <i className="ri-box-3-line text-white text-sm" />
            </div>
            <div>
              <span className="text-base font-bold text-white">GBCOSPACK</span>
              <p className="text-xs text-white/40 mt-0.5">{t('footer.tagline')}</p>
            </div>
          </div>
          <div className="flex items-center gap-6">
            <a href="/terms" className="text-xs text-white/40 hover:text-warm-400 transition-colors">{t('footer.terms')}</a>
            <a href="/privacy" className="text-xs text-white/40 hover:text-warm-400 transition-colors">{t('footer.privacy')}</a>
            <span className="text-xs text-white/30">© 2026 {t('footer.rights')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}